import Vue from "vue";
import { mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import GridComponent from "@/components/child/grid/grid";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import multiSelectComponent from "@/components/child/multiSelect/multiSelect.vue";
import etapasComponent from "@/components/parent/crud/pcp/etapas.vue";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component, Watch } from "@/decorators";
import PaginationModel from "@/models/paginationModel";
import EtapaPCPModel from "@/models/pcp/etapaPCPModel";
import ManipulacaoOrdemPCPModel from "@/models/pcp/manipulacaoOrdemPCPModel";
import UsuarioModel from "@/models/usuarioModel";
import EtapaPCPService from "@/services/etapaPCPService";
import formaFarmaceuticaService from "@/services/formaFarmaceuticaService";
import ManipulacaoOrdemPCPService from "@/services/pcp/manipulacaoOrdemPCPService";
import { AppState } from "@/store/store";
import { addHours } from "@/utils/common/date";

import pcpRapidoComponent from "../../crud/pcp/pcpRapido/pcpRapido.vue";

import "../../crud/crud.scss";
import "../view.scss";

@Component({
    components: {
        actionBarComponent,
        comboComponent,
        etapasComponent,
        dateTimePickerComponent,
        gridComponent,
        pcpRapidoComponent,
        shortcutComponent,
        multiSelectComponent,
    },
    computed: {
        ...mapState<AppState>({
            usuarioLogado: state => state.session.usuarioLogado,
        }),
    },
})
export default class StatusPCPComponent extends Vue {
    private etapaPCPService = new EtapaPCPService();
    private manipulacaoOrdemPCPService = new ManipulacaoOrdemPCPService();
    usuarioLogado: UsuarioModel;

    private shortcutComponent: ShortcutComponent = null;
    gridcomponent: GridComponent = null;

    gridData: ManipulacaoOrdemPCPModel[] = [];
    gridSelectedValues: ManipulacaoOrdemPCPModel[] = [];
    etapaId = null;
    etapaDestinoId = null;
    formasFarmaceuticas = [];
    venda = "";
    etapasOptions: Object[] = [];
    formasFarmaceuticasOptions: Array<Object> = [];
    dataInicial = new Date();
    dataFinal = addHours(3, new Date());
    tipoDocGerar: number = null;
    pags = false;

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("descricaoEtapa", "Descrição Etapa", GridColumnType.String),
            new GridColumn("localEntrega", "Local de Entrega", GridColumnType.String),
            new GridColumn("vendaCodigo", "Venda", GridColumnType.String),
            new GridColumn("manipulacaoOrdemCodigo", "Manipulação", GridColumnType.String),
            new GridColumn("cliente", "Cliente", GridColumnType.String),
            new GridColumn("dataEntrega", "Data de Retirada", GridColumnType.DateTime),
            new GridColumn("paciente", "Paciente", GridColumnType.String),
            new GridColumn("formaFarmaceutica", "Forma", GridColumnType.String),
            new GridColumn("vendedor", "Vendedor", GridColumnType.String),
        ];
    }

    private async onAtualizar() {
        const formasFarmaceuticasIds = this.formasFarmaceuticas.map(f => f.value);

        if (this.dataInicial && this.dataFinal) {
            this.gridData = await this.manipulacaoOrdemPCPService
                .getByEtapa(this.etapaId, this.venda, this.dataInicial, this.dataFinal, formasFarmaceuticasIds)
                .withLoading()
                .resolveWithJSON<ManipulacaoOrdemPCPModel[]>();
        }
    }

    private async onShowEtapasPcp(open: (slot: number, title: string, size: string, fn: () => void) => {}) {
        open(0, "PCP Rápido", "ld-modal", () => {
            this.onAtualizar();
        });
    }

    public async onConfirmAddNew() {
        const ids = this.gridSelectedValues.map(p => p.id);

        if (this.etapaDestinoId) {
            const sucesso = await this.manipulacaoOrdemPCPService
                .updateMany(ids, this.etapaDestinoId)
                .withLoading()
                .resolveWithoutJSON();

            if (sucesso) {
                await this.$showSuccess(this.$t("__.ts.sucesso"), this.$t("__.ts.sucessoApontarEmLote"));
                this.onAtualizar();
                this.etapaDestinoId = 0;
                this.shortcutComponent.hide();
            }
        }
    }

    public async onSelectedValuesChanged(selected: ManipulacaoOrdemPCPModel[]) {
        this.gridSelectedValues = selected;
    }

    public async onApontarEmLote() {
        this.shortcutComponent.title = this.$t("__.ts.apontarEmLote").toString();
        this.shortcutComponent.show();
    }

    @Watch("etapaId")
    @Watch("dataInicial")
    @Watch("dataFinal")
    private async onChangeFilters() {
        await this.onAtualizar();
    }

    @Watch("pags")
    private onPags() {
        if (this.pags) {
            if (this.tipoDocGerar == 0) {
                setTimeout(() => {
                    this.gridcomponent.gerarXls();
                }, 2000);
            }

            if (this.tipoDocGerar == 1) {
                setTimeout(() => {
                    this.gridcomponent.gerarPdf();
                }, 2000);
            }

            if (this.tipoDocGerar == 2) {
                setTimeout(() => {
                    this.gridcomponent.gerarImpressao();
                }, 2000);
            }

            setTimeout(() => {
                this.pags = false;
            }, 2000);
        }
    }

    private onConsulta(model: ManipulacaoOrdemPCPModel) {
        const routeData = this.$router.resolve({ path: `/manipulacaoordem-edicao/${model.manipulacaoOrdemId}` });
        window.open(routeData.href, "_blank");
    }

    private async mounted() {
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.gridcomponent = this.$refs.gridcomponent as GridComponent;

        const etapasAtivas = await this.etapaPCPService.combo(true).resolveWithJSON<PaginationModel<EtapaPCPModel>>();
        this.etapasOptions = etapasAtivas.list.map(item => ({ value: item.id, text: item.descricao }));

        this.formasFarmaceuticasOptions = await formaFarmaceuticaService.comboCached(
            this.usuarioLogado.franquiaId,
            true,
        );
    }
}
